module.exports = __webpack_public_path__ + "static/media/h3.44863731.mp4";